import PlaceSearchPagination = google.maps.places.PlaceSearchPagination;
import PlaceResult = google.maps.places.PlaceResult;

import { PaginatedPlaceResult } from './paginated-place-result.model';


export type PlaceResultCallback = (places: PlaceResult[], status: google.maps.places.PlacesServiceStatus,
                                   pagination: PlaceSearchPagination) => void;


/**
 * Helper class that facilitates loading paginated result sets from the Google Places API.
 */
export class PlaceResultLoader {
  private _promise: Promise<PaginatedPlaceResult> = null;
  private _resolve: (result: PaginatedPlaceResult) => void;
  private _reject: (error: any) => void;

  constructor(
    private _retrieve: (callback: PlaceResultCallback) => void,
    private _handler?: (results: PlaceResult[]) => PlaceResult[]
  ) { }

  async getResults(): Promise<PaginatedPlaceResult> {
    this._promise = new Promise<PaginatedPlaceResult>((resolve, reject) => {
      this._resolve = resolve;
      this._reject = reject;
    });
    this._retrieve(this._onResults.bind(this));
    return this._promise;
  }

  async loadPage(pagination: PlaceSearchPagination): Promise<PaginatedPlaceResult> {
    this._promise = new Promise<PaginatedPlaceResult>((resolve, reject) => {
      this._resolve = resolve;
      this._reject = reject;
    });
    pagination.nextPage();
    return await this._promise;
  }

  private _onResults(places: PlaceResult[], status: google.maps.places.PlacesServiceStatus, pagination: PlaceSearchPagination) {
    try {
      const result = new PaginatedPlaceResult();
      if (status === google.maps.places.PlacesServiceStatus.OK) {
        result.places = this._handler ? this._handler(places) : places;
      } else if (status === google.maps.places.PlacesServiceStatus.ZERO_RESULTS) {
        result.places = [];
      } else {
        this._reject(new Error(status as any as string));
      }
      result.pagination = pagination;
      this._resolve(result);
    } catch (e) {
      this._reject(e);
    }
  }
}
